( function ($) {
    $(document).ready(function () {
        galleryGrid();
        doMasonry('[id^="gallery-"].grid .slider_inner_wrap', '[id^="gallery-"].grid .thumb_wrap');
    });

    function galleryGrid() {
        var wrapper = $('.gallery_section.grid');
        wrapper.each(function () {
            var current = $(this);
            var wrap = current.find('.elements_to_filter');
            wrapper.trigger('builder_gallery_init');
            if (wrap.length > 0) {
                console.log('soul template', wrap);
                wrap.trigger('builder_gallery_ready');
                var thumbHeightShort = wrap.find('.thumb_wrap').eq(0).outerHeight(true);
                var thumbHeightLong = wrap.find('.thumb_wrap').eq(1).outerHeight(true);
                var wrapHeight = wrap.outerHeight(true);
                var startWrapHeight = thumbHeightShort + thumbHeightLong;
                var btnWrap = wrapper.find('.btns_wrap');
                var btn = btnWrap.find('.btn a');
                galleryHeight();

                var select = current.find('.filters_select select');
                select.change(function () {
                    var $this = $(this);

                    $this.trigger('builder_gallery_select_click');

                    var selector = $this.val(),
                        newRel = selector.replace('.', '');
                    wrap.find('.thumb_wrap' + selector).find('.thumb').attr("data-fancybox", newRel + '_thumb');
                    wrap.find('.thumb_wrap' + selector).find('.description').attr("data-fancybox", newRel + '_desc');
                    wrap.find('.thumb_wrap').hide();
                    wrap.find('.thumb_wrap' + selector).show();

                    var btnWrap = current.find('.btns_wrap');
                    wrap.css({
                        height: 'auto',
                        overflow: 'visible'
                    });
                    btnWrap.hide();

                    if (selector == '') {
                        wrap.find('.thumb_wrap').show();
                        if (wrap.hasClass('view_more')) {
                            btn.removeClass('open').text(viewPhotos);
                        }
                        galleryHeight();
                    }
                    return false;
                });
                if (wrap.hasClass('view_more')) {
                    btn.click(function () {
                        if (btn.hasClass('open')) {
                            btn.removeClass('open').text(viewPhotos);
                            wrap.css({
                                height: startWrapHeight,
                                overflow: 'hidden'
                            });
                        } else {
                            btn.addClass('open').text(hidePhotos);
                            wrap.css({
                                height: 'auto',
                                overflow: 'visible'
                            });
                        }
                    });
                }

                function galleryHeight() {
                    if (wrap.hasClass('view_more')) {
                        console.log('wrapheight: ',wrapHeight)
                        if (wrapHeight > startWrapHeight) {
                            wrap.css({
                                height: startWrapHeight,
                                overflow: 'hidden'
                            });
                            btnWrap.show();
                        } else {
                            btnWrap.hide();

                        }
                    }
                }

            }
        });
    }

    function doMasonry(main_container, single_item) {
        if ($('.section.gallery_section.grid').length === 0) return false;
        var width_box;

        if (window.matchMedia("(min-width: 767px) and (max-width: 992px)").matches) {
            width_box = $(main_container).width() / 2;
        } else if (window.matchMedia("(max-width: 767px)").matches) {
            width_box = $(main_container).width();
        } else {
            width_box = $(main_container).width() / 3;
        }

        console.log(width_box);
        console.log($(main_container));

        $(main_container).isotope({
            itemSelector: single_item,
            masonry: {
                columnWidth: width_box,
                horizontalOrder: true,
            }
        });

        //filter items on select
        $('.filters_select select').on('change', function () {
            var filterValue = $(this).val();
            console.log('filter value: ',filterValue);

            $(main_container).isotope({
                filter: filterValue,
            });
            if (filterValue == '') {
                console.log('all items');
                $(main_container).on( 'arrangeComplete',
                    function( event, filteredItems ) {
                        console.log( 'Isotope arrange completed on ' +
                            filteredItems.length + ' items' );
                        $(main_container).isotope('layout');
                    }
                );
            }
        });
    }
}(jQuery) );
